import { useFeatureFlagEnabled, useFeatureFlagVariantKey } from 'posthog-js/react';

const useFeatureFlagEnabledCheck = (featureFlag, testVariant) => {
	const variant = useFeatureFlagVariantKey(featureFlag);
	const isEnabled = useFeatureFlagEnabled(featureFlag);
	return variant === testVariant && isEnabled;
};

export default useFeatureFlagEnabledCheck;
